export function Container({props}) {
  return (
    <div className='container mx-auto border border-gray-400 min-h-[80vh]'>
      {props}
    </div>
  )
}